import { Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import ManagerBase from "./ManagerBase";
import User from "../models/User";
// import User from "../models/User";

class UserManager extends ManagerBase {
	constructor () {
		super("userManager");
		this.remoteClassName = "user";
	}
	
	async checkUserList () {
		const userList = Shark.get();

		if (userList || userList.length === 0) {
			const userListResponse = await this.getList();

			userListResponse.data = Shark.getInstanceList(User, userListResponse.data);
			Shark.set({
				userList: userListResponse.data,
			});

			this.userListResponse = userListResponse;

			return userListResponse;
		}
		else {
			return this.userListResponse;
		}
	}
	// getCurent () {
	// 	const rd = NousCore.api.createRequest();

	// 	return NousCore.api.send("user/get-curent", rd)
	// 	.then(data => {
	// 		if (data.isSuccess) {
	// 			switch (data.rc) {
	// 				case 1:
	// 					const operator = new User(data.items[0]);

	// 					return {
	// 						data: operator,
	// 						status: "ok"
	// 					}
	// 				case 404:
	// 					return {
	// 						data: "",
	// 						status: "ko"
	// 					}
	// 			}
	// 		}
	// 	});
	// }

	async logIn (user) {
		const rd = NousCore.api.createRequest({ item: user.export("logIn") });
		const requestedAction = "login";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						user.import(data.items[0]);
						user.clean();

						return {
							data: user,
							requestedAction,
							status: "ok"
						};
					case 99:
					case 404:
						return {
							data,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}

	register (user) {
		const rd = NousCore.api.createRequest({ item: user.export() });
		const requestedAction = "register";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						user.import(data.items[0]);
						user.clean();

						return {
							data: user,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	requestNewPassword (user) {
		const rd = NousCore.api.createRequest({ item: user.export() });
		const requestedAction = "requestNewPassword";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			console.log({data});
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: user,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	save (userList) {
		let actions = new Set();

		if (!Array.isArray(userList)) {
			userList = [userList];
		}

		userList.forEach(item => {
			actions.add(item.guid === "" ? "insert" : "update");
		});

		if (actions.size > 1) {
			alert("Non posso preosuguire");
			return;
		}
		
		const rd = NousCore.api.createRequest({ item: userList[0].export() });
		const action = Array.from(actions)[0];

		return NousCore.api.send(`${this.remoteClassName}/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						userList.forEach((item, index) => {
							item.import(data.items[index]);
							item.clean();
						});

						return {
							data: userList,
							requestedAction: action,
							status: "ok",
						};
					case 99:
						return {
							data: null,
							requestedAction: action,
							status: "ko",
						};
				}
			}
		});
	}

	saveStatus (user) {
		const rd = NousCore.api.createRequest({ item: {status: user.status} });
		const requestedAction = "set-status";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						user.import(data.items[0]);
						user.clean();

						return {
							data: null,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data: null,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	setNewPassword (user) {
		const rd = NousCore.api.createRequest({ item: {tempKey: Shark.get("tempKey"), ...user.export("logIn")} });
		const requestedAction = "set-new-password";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data,
							requestedAction,
							status: "ok"
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}
	// uploadProfilePicture (target) {
	// 	return NousCore.api.uploadFiles(target, "user/upload-profile-picture").then(function (jsonData) {
	// 		const savedFile = jsonData.payload.items[0];
	
	// 		switch (savedFile.rc) {
	// 			case 1:

	// 				return {
	// 					data: savedFile,
	// 					status: "ok"
	// 				}
	// 			case 95:
	// 				let data = {
	// 					tempFile: savedFile.errors[0].erroData.tempFile,
	// 					originalName: savedFile.errors[0].erroData.originalName,
	// 					type: "pictureURL"
	// 				};

	// 				return {
	// 					data: null,
	// 					status: "ko"
	// 				}
	// 			default:
	// 				alert("Attezione, si è verificato il seguente errore:\n\n" + savedFile.errors[0].errorDescription);
	// 		}
	// 	});
	// }
}

const userManager = new UserManager();

Shark.registerController(userManager);

export default userManager;
